/**
 * Prefurn Product Description Enhancer
 * - Converts FAQ H3+P sections to native <details>/<summary> accordions
 * - Injects B2B CTA on new product pages (not refurbished/showroom)
 */
(function () {
  'use strict';

  function initFaqAccordion() {
    var descriptions = document.querySelectorAll(
      '.product-single--detail .rte, .product__description .rte, .product-description, [data-product-description], .product-information .rte'
    );

    if (descriptions.length === 0) {
      var productContainer = document.querySelector('.thb-product-detail, .product, [data-product]');
      if (productContainer) {
        descriptions = productContainer.querySelectorAll('.rte');
      }
    }

    descriptions.forEach(function (desc) {
      var allH2 = desc.querySelectorAll('h2');
      var faqHeading = null;
      for (var i = 0; i < allH2.length; i++) {
        if (/veelgestelde|faq/i.test(allH2[i].textContent)) {
          faqHeading = allH2[i];
          break;
        }
      }
      if (!faqHeading) return;

      var faqContainer = document.createElement('div');
      faqContainer.className = 'product-faq';

      var current = faqHeading.nextElementSibling;
      var toRemove = [];

      while (current && current.tagName !== 'H2') {
        if (current.tagName === 'H3') {
          var questionText = current.textContent.trim();
          var details = document.createElement('details');
          var summary = document.createElement('summary');
          summary.textContent = questionText;
          details.appendChild(summary);

          var answerDiv = document.createElement('div');
          answerDiv.className = 'faq-answer';

          var next = current.nextElementSibling;
          while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
            answerDiv.appendChild(next.cloneNode(true));
            toRemove.push(next);
            next = next.nextElementSibling;
          }

          details.appendChild(answerDiv);
          faqContainer.appendChild(details);
          toRemove.push(current);
          current = next;
        } else {
          current = current.nextElementSibling;
        }
      }

      if (faqContainer.children.length > 0) {
        toRemove.forEach(function (el) {
          if (el.parentNode) el.parentNode.removeChild(el);
        });
        faqHeading.parentNode.insertBefore(faqContainer, faqHeading.nextSibling);
      }
    });
  }

  function initB2BCta() {
    // Only on new chairs — skip refurbished and showroom
    var h1 = document.querySelector('h1');
    if (!h1) return;
    if (/refurbished|showroom/i.test(h1.textContent)) return;

    // Don't double-inject
    if (document.querySelector('.b2b-cta')) return;

    // Find the product description container
    var desc = document.querySelector(
      '.product-single--detail .rte, .product__description .rte, .product-description, [data-product-description], .product-information .rte'
    );
    if (!desc) {
      var productContainer = document.querySelector('.thb-product-detail, .product, [data-product]');
      if (productContainer) desc = productContainer.querySelector('.rte');
    }
    if (!desc) return;

    var cta = document.createElement('div');
    cta.className = 'b2b-cta';
    cta.innerHTML =
      '<div class="b2b-cta__body">'
      + '<strong class="b2b-cta__title">Koopt u stoelen als bedrijf?</strong>'
      + '<p class="b2b-cta__text">Vraag ons naar de beste aanbieding voor uw kantoor.</p>'
      + '</div>'
      + '<a href="mailto:info@prefurn.nl" class="b2b-cta__button">Offerte aanvragen</a>';

    desc.appendChild(cta);
  }

  function init() {
    initFaqAccordion();
    initB2BCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
